import { WebApp } from '@grammyjs/web-app'

export const useError = (text: string) => {
    WebApp.showPopup({
        title: 'Ошибка',
        message: text
    })
    WebApp.HapticFeedback.notificationOccurred('error')
}
